import { DataSource, Label, Layout } from "@mcleod/components";

export abstract class AutogenLayoutDatafusionBillingPending extends Layout {
    labelInDataFusionInvoices: Label;
    labelT: Label;
    sourceEdibillingPending: DataSource;
}
